module.exports = __webpack_public_path__ + "static/media/gorne-wy.22335052.svg";